module.exports = __webpack_public_path__ + "static/media/mapa.ad1f1013.jpg";